/* Decorative motion only: compositor animation, no network or commerce changes. */
(() => {
  const candy=document.querySelector('[data-sfhg-launcher]');
  if(!candy||!candy.animate)return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let flight=null,frame=0,resumeTimer=0,routeKey='';
  const targets='button[name="checkout"],button[type="submit"],.shopify-payment-button,.sf-sticky-atc,sticky-add-to-cart';
  const interacting=()=>candy.matches(':hover')||candy.contains(document.activeElement);
  function pause(){flight?.pause();candy.dataset.sfhgMotionPaused='true';}
  function resume(){
    clearTimeout(resumeTimer);
    resumeTimer=setTimeout(()=>{
      if(candy.hidden||document.hidden||reduced.matches||interacting())return;
      delete candy.dataset.sfhgMotionPaused;layout();flight?.play();
    },1000);
  }
  function stop(){flight?.cancel();flight=null;routeKey='';candy.classList.remove('sfhg-roaming');}
  function layout(){
    frame=0;
    if(candy.hidden||reduced.matches){stop();return;}
    if(document.hidden){pause();return;}
    const width=window.innerWidth,height=window.innerHeight,w=candy.offsetWidth,h=candy.offsetHeight;
    const left=14,right=Math.max(left,width-w-14),top=100,bottom=Math.max(top,height-h-115);
    let bands=[[top,bottom]];
    // One horizontal travel band is kept clear of purchase buttons for the whole route.
    document.querySelectorAll(targets).forEach(button=>{
      const r=button.getBoundingClientRect();
      if(!r.width||!r.height||r.bottom<=0||r.top>=height)return;
      const a=r.top-h-24,b=r.bottom+24;
      bands=bands.flatMap(([lo,hi])=>b<=lo||a>=hi?[[lo,hi]]:[[lo,Math.min(hi,a)],[Math.max(lo,b),hi]].filter(([l,u])=>u>=l));
    });
    const band=bands.sort((a,b)=>(b[1]-b[0])-(a[1]-a[0]))[0];
    if(!band||height<h+200){stop();return;}
    const key=[width,height,w,h,...band.map(Math.round)].join(':');
    if(key===routeKey&&flight)return;
    const current=candy.getBoundingClientRect();
    routeKey=key;
    const clamp=(v,lo,hi)=>Math.max(lo,Math.min(v,hi));
    const start={x:clamp(current.left,left,right),y:clamp(current.top,band[0],band[1])};
    const point=(x,y)=>({x:left+(right-left)*x,y:band[0]+(band[1]-band[0])*y});
    const points=[start,point(.72,.12),point(.04,.35),point(.25,.93),point(.98,.58),start];
    const frames=points.map(p=>({transform:`translate3d(${p.x}px,${p.y}px,0)`,easing:'ease-in-out'}));
    flight?.cancel();candy.classList.add('sfhg-roaming');
    flight=candy.animate(frames,{duration:30000,iterations:Infinity});
    if(interacting()||candy.dataset.sfhgMotionPaused==='true')pause();
  }
  function schedule(){if(!frame&&!candy.hidden)frame=requestAnimationFrame(layout);}
  candy.addEventListener('pointerenter',pause);
  candy.addEventListener('pointerdown',pause);
  candy.addEventListener('focusin',pause);
  candy.addEventListener('pointerleave',resume);
  candy.addEventListener('pointerup',resume);
  candy.addEventListener('pointercancel',resume);
  candy.addEventListener('focusout',resume);
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('scroll',schedule,{passive:true});
  window.visualViewport?.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('visibilitychange',()=>document.hidden?pause():resume());
  reduced.addEventListener('change',()=>{stop();schedule();});
  new MutationObserver(()=>candy.hidden?stop():schedule()).observe(candy,{attributes:true,attributeFilter:['hidden']});
  schedule();
})();
